import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import LoadingAnimation from "../components/LoadingAnimation";

function CertificateSlider() {
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Desired order
  const certificateOrder = ["P@SHA", "PSEB", "PESSI", "PSW", "GTCCI"];

  useEffect(() => {
    fetchCertificates();
  }, []);

  const fetchCertificates = async () => {
    setLoading(true);
    try {
      const querySnapshot = await getDocs(collection(db, "certifications"));
      const certificatesData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const sortedCertificates = certificatesData.sort((a, b) => {
        const indexA = certificateOrder.indexOf(a.title);
        const indexB = certificateOrder.indexOf(b.title);
        
        if (indexA === -1 && indexB === -1) return 0;
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      });

      setCertificates(sortedCertificates);
      setError(null);
    } catch (err) {
      console.error("Error fetching certificates:", err);
      setError("Failed to load certifications.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="cert-section">
        <div className="section-header">
         
        </div>
        <LoadingAnimation />
      </section>
    );
  }

  if (error) {
    return (
      <section className="cert-section">
        <div className="section-header">
          <h1>PROUD <span>MEMBER</span> OF</h1>
        </div>
        <div className="error-msg">
          <p>{error}</p>
          <button onClick={fetchCertificates}>Retry</button>
        </div>
      </section>
    );
  }

  if (certificates.length === 0) {
    return null;
  }

  return (
    <section className="cert-section">
      <div className="section-header">
        <h1>PROUD <span>MEMBERS</span> OF</h1>
      </div>

      <div className="cert-vertical-container">
        {certificates.map((cert) => (
          <div key={cert.id} className="cert-item">
            <div className="cert-title">
              <h3>✦ {cert.title} ✦</h3>
              {/* Description added here */}
              {cert.description && (
                <p className="cert-description">{cert.description}</p>
              )}
            </div>
            <div className="cert-image">
              <img src={cert.image} alt={cert.title} />
            </div>
          </div>
        ))}
      </div>

      <style>{`
        .cert-section {
          width: 100%;
          background: #fff;
          padding: 0;
          margin: 0;
        }

        .section-header {
          text-align: center;
          padding: 40px 20px 20px 20px;
        }

        .section-header h1 {
          font-size: 2rem;
          margin: 0;
          color: #222;
        }

        .section-header span {
          color: #FF8000;
        }

        .cert-vertical-container {
          width: 100%;
          max-width: 900px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 50px;
          padding: 20px;
        }

        .cert-item {
          width: 80%;
          text-align: center;
          background: #fff;
          border-radius: 20px;
          padding: 30px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        }

        .cert-title {
          margin-bottom: 25px;
        }

        .cert-title h3 {
          margin: 0 0 15px 0;
          font-size: 1.5rem;
          color: #222;
        }

        .cert-description {
          margin: 0;
          font-size: 1rem;
          color: #666;
          line-height: 1.6;
          text-align: center;
          max-width: 80%;
          margin-left: auto;
          margin-right: auto;
        }

        .cert-image {
          width: 100%;
          background: #f8f9fa;
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .cert-image img {
          width: 100%;
          height: auto;
          object-fit: contain;
        }

        .error-msg {
          text-align: center;
          padding: 40px;
        }

        .error-msg button {
          background: #FF8000;
          color: white;
          border: none;
          padding: 10px 24px;
          border-radius: 8px;
          cursor: pointer;
          margin-top: 15px;
        }

        /* Tablet */
        @media (max-width: 1024px) {
          .cert-item {
            width: 85%;
            padding: 25px;
          }
         
          .cert-title h3 {
            font-size: 1.3rem;
          }
          
          .cert-description {
            font-size: 0.95rem;
            max-width: 85%;
          }
        }

        /* Mobile */
        @media (max-width: 768px) {
          .section-header {
            padding: 30px 15px 15px 15px;
          }
          .section-header h1 {
            font-size: 1.5rem;
          }
          .cert-vertical-container {
            gap: 30px;
            padding: 15px;
          }
          .cert-item {
            width: 90%;
            padding: 20px;
          }
          
          .cert-title h3 {
            font-size: 1.2rem;
            margin: 0 0 15px 0;
          }
          
          .cert-description {
            font-size: 0.9rem;
            max-width: 90%;
          }
        }

        /* Small Mobile */
        @media (max-width: 480px) {
          .cert-vertical-container {
            gap: 25px;
            padding: 10px;
          }
          .cert-item {
            width: 95%;
            padding: 15px;
          }
       
          .cert-title h3 {
            font-size: 1rem;
            margin: 0 0 12px 0;
          }
          
          .cert-description {
            font-size: 0.85rem;
            max-width: 95%;
            line-height: 1.4;
          }
        }
      `}</style>
    </section>
  );
}

export default CertificateSlider;